import React from 'react'
import { Form, Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import T from 'prop-types'
import Button from '@material-ui/core/Button'
import Input from 'components/common/Form/Input'
import getValidator, {
  VALIDATOR_IS_EMPTY,
  VALIDATOR_PASSWORD,
  VALIDATOR_PASSWORDS_EQUAL,
} from 'validation'
import messages from './translate'

function RecoveryPasswordForm({ intl: { formatMessage }, onSubmit }) {
  return (
    <Form
      validateOnBlur
      onSubmit={onSubmit}
      render={({
        handleSubmit,
        submitting,
        submitError,
        dirtySinceLastSubmit,
        values,
      }) => {
        const isShowSubmitError =
          Boolean(submitError) && !dirtySinceLastSubmit && !submitting
        const { new_password, confirm_password } = values
        const confirmPasswordValidators = [
          VALIDATOR_IS_EMPTY,
          VALIDATOR_PASSWORD,
        ]

        if (confirm_password) {
          const comparePasswords = confirm_password !== new_password

          if (comparePasswords) {
            confirmPasswordValidators.push(VALIDATOR_PASSWORDS_EQUAL)
          }
        }

        return (
          <form onSubmit={handleSubmit}>
            {isShowSubmitError && (
              <div className="error static">{submitError}</div>
            )}
            <Field
              name="new_password"
              label={formatMessage(messages.new_password)}
              className="form-control-lg"
              render={props => <Input type="password" {...props} />}
              disabled={submitting}
              validate={getValidator([VALIDATOR_IS_EMPTY, VALIDATOR_PASSWORD])}
            />
            <Field
              name="confirm_password"
              label={formatMessage(messages.confirm_password)}
              className="form-control-lg"
              render={props => <Input type="password" {...props} />}
              disabled={submitting}
              validate={getValidator(confirmPasswordValidators)}
            />
            <div className="form-group">
              <Button
                fullWidth
                href={null}
                type="submit"
                color="primary"
                size="large"
                variant="contained"
                onClick={handleSubmit}
                disabled={submitting}>
                {formatMessage(messages.submit)}
              </Button>
            </div>
          </form>
        )
      }}
    />
  )
}

RecoveryPasswordForm.propTypes = {
  intl: T.shape({
    formatMessage: T.func,
  }).isRequired,
  onSubmit: T.func.isRequired,
}

const enhance = injectIntl

export default enhance(RecoveryPasswordForm)
